var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('v-alert',{attrs:{"color":_vm.formItem.color,"dark":"","icon":_vm.formItem.icon,"border":"left","prominent":"","outlined":_vm.formItem.outlined}},[_c('div',{domProps:{"textContent":_vm._s(_vm.title)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }